
const state = () => ({
    showSideBar: false,
    idSummarySelected:'',
    idSummarySelectedMultiple: [],
    idSummarySelectedLink:'all',
    typeTicketSelected:'none',
    planActionRef: null,
    tasksRef:null,
    activites:[],
    listLevels : [],
    listTypesTickets: [],
    listProjets : [],
    selectedActivite:"none",
    selectedActiviteMultiple: [],
    selectedActiviteLink:"none",
    listTickets: [],
    duplicate: false,
    codeProjet:'',
    couleur: '',
    task:{},
    ticketDialog: false,
    etatTask: 'none',
    mode:'filtres',
    typeRequest:'global',
    loadParams: 'false',
    adminId:'',
    currentUId:'',
    displayName:'',
    priorite:'',
    provenance:'',
    classeur:'',
    couriser:'',
    email:'',
    accord:'',
    photo:'',
    etiquette:'',
    checkItems:[],
    listLinks: [],
    dialog :{
         typeTicket: false,
         listTask:false
    },
    userSession: {},
    filterOption: "dateFilterYear",
    filterSelected: "",
    selectedDate:"",
    currentAgendaTicket:{}
})
// getters
const getters = {
    getIdSummary:(state)=> state.idSummarySelected ,
    getDialogListTask: state => {
        return state.dialog.listTask;
    }
}

// actions
const actions = {}

// muatations
const mutations = {
    setShowMenu(state, displayMenu){
        state.showSideBar = displayMenu
    },
    setSummary(state, data){
         state.idSummarySelected = data
    },
    setSummaryMultiple(state, data){
        state.idSummarySelectedMultiple = data
   },
    setSummaryLink(state, data){
        state.idSummarySelectedLink = data
   },
    setPlanActionRef(state, data){
        state.planActionRef = data
   },
   setTasksRef(state, ref){
    state.tasksRef = ref
    },
    setCouleur(state, couleur){
        state.couleur = couleur
    },
    setCurrentUId(state, currentUId){
        state.currentUId = currentUId
    },
    setPriorite(state, priorite){
        state.priorite = priorite
    },
    setAdminId(state, adminId){
        state.adminId = adminId
    },
    setListTickets(state, listTickets){
        state.listTickets = listTickets
    },
    //DisplayDialog
    displayDialog(state, payload){
        state.dialog[payload.var] = payload.display
   },
   setDisplayListTicket(state, display){
       state.dialog.listTask = display
   },
   setCodeProjet(state,codeProjet){
       state.codeProjet = codeProjet
   },
   setTask(state, task) {
        state.task= task
   },
   setMode(state, mode) {
    state.mode= mode
},
  setActivites(state, activites) {
    state.activites= activites
},
  setSelectedActivite(state, id) {
    state.selectedActivite= id
},
setSelectedActiviteMultiple(state, listActivites) {
    state.selectedActiviteMultiple= listActivites

},
    setSelectedActiviteLink(state, id) {
        state.selectedActiviteLink= id
    },
    setListProjets(state, projets) {
        state.listProjets = projets
    },
    setListTypesTickets(state, list) {
    state.listTypesTickets = list
    },
    setTypeTicketSelected(state, id) {
    state.typeTicketSelected = id
    },
    setEtatTask(state, etat) {
        state.etatTask = etat
    },
    setEtiquette(state, etiquette) {
        state.etiquette = etiquette
    },
    setProvenance(state, provenance) {
        state.provenance = provenance
    },
    setClasseur(state, classeur) {
        state.classeur = classeur
    },
    setCoursier(state, couriser) {
        state.couriser = couriser
    },
    setAccord(state, accord) {
        state.accord = accord
    },
    setTicketDialog(state, display) {
        state.ticketDialog = display
    },
    setDuplicate(state, isDuplicate){
        state.duplicate = isDuplicate
    },
    setListLinks(state, link){
        state.listLinks.push(link)
    },
    setTypeRequest(state, request) {
        state.typeRequest = request
    },
    setDisplayName(state, displayName) {
        state.displayName = displayName
    },
    setEmail(state, email) {
        state.email = email
    },
    setUserSession(state, session) {
        state.userSession = session
    },
    setCheckItems(state, item) {
        state.checkItems = item
    },
    setPhoto(state, photo) {
        state.photo = photo
    },
    setFilterOption(state, option) {
         state.filterOption = option
    },
    setFilterSelected(state, selected){
        state.filterSelected = selected
    },
    setLoadParams(state, value){
        state.loadParams = value
    },
    setListLevels(state, value){
        state.listLevels = value
    },
    setSelectedDate(state, value){
        state.selectedDate= value
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }